<template>
  <div class="register">
    <div class="container">
       <div class="registerType">
        <div :class="['registerTypeitem', 'bg1', { active: type == 1 }]" @click="type = 1">
          组织/机构
        </div>
        <div :class="['registerTypeitem', 'bg2', { active: type == 2 }]" @click="type = 2">
          个人/成员
        </div>
      </div>
      <div class="team" v-show="type == 1">
        <el-form ref="form" :rules="dataRule" :model="form" label-width="120px">
            <el-form-item label="组织类型" prop="type">
              <el-select v-model="form.type" placeholder="请选组织类型">
                <el-option label="各级红会" value="1"></el-option>
                <el-option label="养老机构" value="2"></el-option>
                <el-option label="志愿者组织" value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="组织名称" prop="realName">
              <el-input v-model="form.realName"></el-input>
            </el-form-item>
          
            <el-form-item  label="组织地址" prop="allAddress">
             <el-cascader ref="myCascader" :props="props" v-model="allAddress" @change="changeAdress"></el-cascader>
            </el-form-item>
            <el-form-item label="补充地址" prop="detailedAddress">
              <el-input v-model="form.detailedAddress"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="form.contacts"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="contactsPhone">
              <el-input v-model="form.contactsPhone"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idnumber">
              <el-input v-model="form.idnumber"></el-input>
            </el-form-item>
            <el-form-item label="组织标识" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="baseurl + '/organization/organization/uploadLogoImg'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                name='img'>
                <img v-if="form.logo" :src="baseurl + form.logo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="相关证书" prop="certificate">
              <el-upload
                class="avatar-uploader"
                :action="baseurl + '/organization/organization/uploadLogoImg'"
                :show-file-list="false"
                :on-success="certificatehandleAvatarSuccess"
                name='img'>
                <img v-if="form.certificate" :src="baseurl + form.certificate" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="form.userName"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item label="座机号码" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="组织规模" prop="scale">
              <el-input v-model="form.scale"></el-input>
            </el-form-item>
            <el-form-item class="submitbtn">
              <el-button type="primary" @click="onSubmit">立即申请</el-button>
            </el-form-item>
          </el-form>
      </div>
      <div class="self"  v-show="type == 2">
          <el-form ref="selfform" :rules="selfdataRule" :model="selfform" label-width="120px">
            <el-form-item  label="居住地址" prop="allAddress">
             <el-cascader ref="myCascader" :props="props" v-model="allAddress" @change="changeAdress"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="detailedAddress">
              <el-input v-model="selfform.detailedAddress "></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="selfform.email"></el-input>
            </el-form-item>
            <el-form-item label="头像" prop="header">
              <el-upload
                class="avatar-uploader"
                :action="baseurl + '/organization/organization/uploadLogoImg'"
                :show-file-list="false"
                :on-success="headerhandleAvatarSuccess"
                name='img'>
                <img v-if="selfform.header" :src="baseurl + selfform.header" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证号" prop="idnumber">
              <el-input v-model="selfform.idnumber"></el-input>
            </el-form-item>
            <el-form-item label="个人简介" prop="introduction">
              <el-input type="textarea" v-model="selfform.introduction"></el-input>
            </el-form-item>
            <el-form-item label="民族" prop="nation">
              <el-input v-model="selfform.nation"></el-input>
            </el-form-item>
            <el-form-item label="昵称" prop="nickname">
              <el-input v-model="selfform.nickname"></el-input>
            </el-form-item>
            <el-form-item label="所属组织" prop="type">
              <el-select v-model="selfform.organizationId" placeholder="请选组织/机构">
                <el-option :label="item.realName" :value="item.id" :key="item.id" v-for="item in typeList2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="selfform.password"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input v-model="selfform.phone"></el-input>
            </el-form-item>
            <el-form-item label="政治面貌" prop="politics">
              <el-input v-model="selfform.politics"></el-input>
            </el-form-item>
            <el-form-item label="从事职业" prop="profession">
              <el-input v-model="selfform.profession"></el-input>
            </el-form-item>
            <el-form-item label="服务类型" prop="publishId">
              <el-select v-model="selfform.type" placeholder="请选组织类型">
                <el-option :label="item.typeName" :value="item.id" :key="item.id" v-for="item in typeList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="realName">
              <el-input v-model="selfform.realName"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="selfform.sex">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="selfform.userName"></el-input>
            </el-form-item>
            <el-form-item class="submitbtn">
              <el-button type="primary" @click="onSubmit2">立即申请</el-button>
            </el-form-item>
          </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    let That = this;
    return {
       props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level == 0) {
            var params = {
              code: "",
              level: "1",
            };
          } else {
            var params = {
              code: node.value,
              level: level + 1,
            };
          }
          That.$http
            .get(
              `City/city/getAllCity2?code=${params.code}&level=${params.level}`
            )
            .then((res) => {
              if (res.data.code == 0) {
                const nodes = res.data.data.map((item) => ({
                  value: item.criCode,
                  label: item.criName,
                  leaf: parseInt(item.criLevel) - 1 >= 2,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
        },
      },
      selfdataRule: {
        nickname: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        password: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        idnumber: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        realName: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        userName: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
      },
      dataRule: {
        type: [
            { required: true, message: '必填项不能为空', trigger: 'change' }
        ],
        realName: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        userName: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        contacts: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        contactsPhone: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        idnumber: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
        password: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
        ],
      },
      baseurl: this.$baseurl,
      type: '1',
      allAddress: [],
      form: {
        type: '',
        realName: '',
        contacts: '',
        contactsPhone: '',
        email: '',
        idnumber: '',
        logo: '',
        password: '',
        phone: '',
        scale: '',
        userName: '',
        detailedAddress : '',
        certificate: ''
      },
      selfform: {
        organizationId: '',
        detailedAddress: '',
        email: '',
        header: '',
        idnumber: '',
        introduction: '',
        nation: '',
        nickname: '',
        type: '',
        password: '',
        phone: '',
        politics: '',
        profession: '',
        publishId: '',
        realName: '',
        sex: '',
        userName: '',
      },
      typeList: [],
      typeList2: []
    }
  },
  mounted() {
    this.gettype()
    this.gettype2()
  },
  methods: {
    async gettype2() {
      let { data: { data, code }} = await this.$http.get('/organization/organization/page', { params: { page: 1, limit: 10000}})
      if(code != 0) return
      this.typeList2 = data.list
    },
    async gettype() {
      let { data: { data, code }} = await this.$http.get('api/publishtype/selectAll') 
      if(code != 0) return
      this.typeList = data
    },
    headerhandleAvatarSuccess(res, file) {
      console.log(res);
      if(res.code != 0) return
      this.selfform.header = res.data.logo
    },
    certificatehandleAvatarSuccess(res, file) {
      console.log(res);
      if(res.code != 0) return
      this.form.certificate = res.data.logo
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      if(res.code != 0) return
      this.form.logo = res.data.logo
      console.log(file);
    },
     changeAdress(value) {
      console.log(this.$refs["myCascader"].inputValue);
    },
    async onSubmit() {
      let type = false
      this.$refs.form.validate((valid) => {
        if (!valid) type = true
      });
      if(type) return
      this.form.sheng = this.allAddress[0]
      this.form.shi = this.allAddress[1]
      this.form.qu = this.allAddress[2]
      let { data: { code }} = await this.$http.post('/organization/organization', this.form)
      if(code != 0) return this.open('申请提交失败!')
      this.open('申请提交成功!')
    },
    async onSubmit2() {
      let type = false
      this.$refs.selfform.validate((valid) => {
        if (!valid) type = true
      });
      if(type) return
      this.selfform.sheng = this.allAddress[0]
      this.selfform.shi = this.allAddress[1]
      this.selfform.qu = this.allAddress[2]
      let { data: { code }} = await this.$http.post('/volunteer/volunteer', this.selfform)
      if(code != 0) return this.open('申请提交失败!')
      this.open('申请提交成功!')
     
    },
     open(info) {
        this.$alert(info, '提示', {
          confirmButtonText: '确定'
        });
      }
    
    
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.register {
  .submitbtn {
    display: flex;
    justify-content: flex-end;
  }
    .avatar-uploader .el-upload {
    border: 1px dashed #fff;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 2px solid #fff;
    background-color: #fff;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
    background-color: #f0f0f0;
    padding: 30px 0;
    .registerType {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .registerTypeitem {
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        flex: 1;
        text-align: center;
        height: 100px;
        line-height: 100px;
        margin: 30px;
        cursor: pointer;
        border-radius: 6px;
      }
      .bg1 {
        background: linear-gradient(#74e9ac, #59d1c3, #3cb6dd, #1a98fb);
      }
      .bg2 {
        background: linear-gradient(#f2a7f7, #9d9ffa, #5e99fc, #1a98fb);
      }
      .active {
        box-shadow: 0px 0px 9px 2px #ffbe76;
      }
    }
}
</style>